<div class="rule">
  <p *ngIf="rule.noteTop" class="text-white" [ghs-label]="rule.noteTop"></p>
  <div class="spawns" *ngIf="gameManager.scenarioRulesManager.spawns(rule).length > 0">
    <ng-container *ngFor="let spawn of gameManager.scenarioRulesManager.spawns(rule); let i = index">
      <span class="and" *ngIf="i > 0" [ghs-label]="'and'"></span>
      <span class="text-white text" [ghs-label]="'scenario.rules.spawn' + (spawn.marker ? 'Marker' : '')"
        [ghs-label-args]="[spawn.monster.name, gameManager.scenarioRulesManager.spawnType(spawn.monster) || '', spawn.count ? gameManager.scenarioRulesManager.spawnCount(rule, spawn) + ' ' : '', spawn.marker]"></span>
      <input type="number" *ngIf="spawn.manual" [(ngModel)]="spawn.count" [min]="spawn.manualMin || 0"
        [max]="spawn.manualMax || ''">
    </ng-container>
  </div>
  <div class="objective-spawns" *ngIf="!!rule.objectiveSpawns && rule.objectiveSpawns.length > 0">
    <ng-container *ngFor="let spawn of rule.objectiveSpawns; let i = index">
      <span class="and" *ngIf="i > 0" [ghs-label]="'and'"></span>
      <span class="text-white text"
        [ghs-label]="'scenario.rules.spawnObjective' + ( EntityValueFunction(spawn.count || 1) > 1 ? 's' : '') + (spawn.objective.escort ? 'Escort' : '') + (spawn.marker ? 'Marker' : '')"
        [ghs-label-args]="[spawn.objective.name ? 'data.objective.' + spawn.objective.name : '',  EntityValueFunction(spawn.count || 1) + ' ', spawn.marker]"></span>
      <input type="number" *ngIf="spawn.manual" [(ngModel)]="spawn.count" [min]="spawn.manualMin || 0"
        [max]="spawn.manualMax || ''" [value]="EntityValueFunction(spawn.count || 1)">
    </ng-container>
  </div>
  <div class="elements" *ngIf="!!rule.elements && rule.elements.length > 0">
    <ng-container *ngFor="let element of rule.elements; let i = index">
      <span class="and" *ngIf="i > 0">,</span>
      <span class="element">
        <ghs-element-icon [element]="element"></ghs-element-icon>
        <span><span [ghs-label]="'game.element.' + element.type"></span></span>
        <span><span [ghs-label]="'game.element.state.' + element.state"></span></span>
      </span>
    </ng-container>
  </div>
  <div class="sections rooms" *ngIf="rooms().length > 0">
    <ng-container *ngFor="let roomData of rooms(); let i = index">
      <span class="section room">
        <img class="ghs-svg" src="./assets/images/scenario/door.svg">
        <span class="text-white"
          [ghs-label]="roomData.marker ? 'scenario.rules.openRoomMarker' : 'scenario.rules.openRoom'"
          [ghs-label-args]="[roomData.marker || '']"></span>
      </span>
    </ng-container>
  </div>
  <div class="sections" *ngIf="sections().length > 0">
    <ng-container *ngFor="let sectionData of sections(); let i = index">
      <span class="and" *ngIf="i > 0">,</span>
      <span class="section">
        <img class="ghs-svg" src="./assets/images/lock.svg">
        <span class="text-white" *ngIf="!sectionData.conclusion"
          [ghs-label]="(sectionData.marker ? 'scenario.rules.addSectionMarker' : 'scenario.rules.addSection') + (sectionData.hideIndex ? '' : 'Index')"
          [ghs-label-args]="[sectionData.index, gameManager.scenarioManager.scenarioTitle(sectionData,true), sectionData.marker || '']"></span>
        <span class="text-white" *ngIf="sectionData.conclusion" [ghs-label]=" 'scenario.rules.finishWithConclusion'"
          [ghs-label-args]="[sectionData.index, gameManager.scenarioManager.scenarioTitle(sectionData,true), sectionData.marker || '']"></span>
      </span>
    </ng-container>
  </div>
  <div class="figures" *ngIf="figureRules().length > 0">
    <ng-container *ngFor="let figureRule of figureRules();">
      <span class="figure">
        <span class="text-white" [ghs-label]="'scenario.rules.figures.' + figureRule.type"
          [ghs-label-args]="[figureNames(figureRule), figureRule.value || '', (settingsManager.settings.calculate && (figureRule.type == 'damage' && figureRule.value && figureRule.value.indexOf('H') == -1 || (figureRule.type == 'setHp' || figureRule.type == 'heal') && figureRule.value && figureRule.value.indexOf('H') == -1)) ? EntityValueFunction(figureRule.value || '') : (figureRule.value || ''), (figureRule.type == 'amAdd' || figureRule.type == 'amRemove') ? figureRule.value.split(':')[0] : '', (figureRule.type == 'amAdd' || figureRule.type == 'amRemove' || figureRule.type == 'transfer' && figureRule.value && figureRule.value.split(':').length > 1) ? figureRule.value.split(':')[1] : '', figureRule.type == 'transferEntities' && figureRule.identifier && figureRule.identifier.number ? figureRule.identifier.number : '']"></span>
        <span *ngIf="figureRule.scenarioEffect" class="text-white">
          <span [ghs-label]="'scenario.rules.figures.scenarioEffect'"></span>
        </span>
      </span>
    </ng-container>
  </div>
  <div class="random-dungeon" *ngIf="rule.randomDungeon">
    <p *ngIf="rule.randomDungeon.dungeonCount" class="text-white"
      [ghs-label]="'scenario.rules.randomDungeon.dungeon' + (rule.randomDungeon.dungeonCards && rule.randomDungeon.dungeonCards.length ? '.cards' : '')"
      [ghs-label-args]="[rule.randomDungeon.dungeonCount, randomDungeonsDungeonLabel().toString()]">
    </p>
    <br *ngIf="rule.randomDungeon.dungeonCount && rule.randomDungeon.monsterCount">
    <p *ngIf="rule.randomDungeon.monsterCount" class="text-white"
      [ghs-label]="'scenario.rules.randomDungeon.monster' + (rule.randomDungeon.monsterCards && rule.randomDungeon.monsterCards.length ? '.cards' : '')"
      [ghs-label-args]="[rule.randomDungeon.monsterCount, randomDungeonsMonsterLabel(rule).toString()]">
    </p>
  </div>
  <div class="stat-effects" *ngIf="!!rule.statEffects && rule.statEffects.length">
    <div class="text text-white" *ngFor="let statEffectRule of rule.statEffects" [ghs-label]="statEffectRule.note">
    </div>
  </div>
  <p *ngIf="rule.finish" class="text-white" [ghs-label]="'scenario.rules.finish.' + rule.finish"></p>
  <p *ngIf="rule.note" class="text-white" [ghs-label]="rule.note"></p>
  <p *ngIf="rule.alwaysApplyTurn" class="text-white"
    [ghs-label]="'scenario.rules.alwaysApplyTurn.' + rule.alwaysApplyTurn"></p>
</div>